module.exports = ".table-meta .table-actions .col-left{overflow:hidden}.table-meta .table-actions .col-right{width:auto}\n"